import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setModalStateById } from 'automation-ui-canvas/actions/MenuBarActions';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { OPEN_QUERY_PARAM, REDIRECT_TO_PANEL } from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
import { useHistory } from 'react-router-dom';
const useOpenMenu = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const openMenu = useCallback(({
    menuOptionId,
    redirectMenuOptionId,
    initialState
  }) => {
    if (initialState) {
      dispatch(setModalStateById({
        menuOptionId,
        modalState: initialState
      }));
    }
    const queryUpdate = {
      [OPEN_QUERY_PARAM]: menuOptionId
    };
    if (redirectMenuOptionId) {
      queryUpdate[REDIRECT_TO_PANEL] = redirectMenuOptionId;
    }
    atomicQueryUpdate(queryUpdate, [], history);
  }, [dispatch, history]);
  return openMenu;
};
export default useOpenMenu;